import Vue from 'vue';
import Router from 'vue-router';
import SchoolSelection from '@/components/schools/SchoolSelection';
import ReportSelection from '@/components/reports/ReportSelection';
import TeacherSelection from '@/components/teachers/TeacherSelection';
import UnpaidInvoices from '@/components/invoices/UnpaidInvoices';
import PaidInvoices from '@/components/invoices/PaidInvoices';
import ManageSchool from '@/components/schools/ManageSchool';
import ManageTeachers from '@/components/teachers/ManageTeachers';
import SchoolDetails from '@/components/schools/SchoolDetails';
import CheckoutSuccess from '@/components/schools/CheckoutSuccess';
import CheckoutFailure from '@/components/schools/CheckoutFailure';
import WebsiteIndex from '@/components/website/Index';
import WebsiteNews from '@/components/website/news/NewsSelection';
import Home from '@/components/Home';
import InvoicesIndex from '@/components/invoices/Index';
import LicensesSelection from '@/components/licenses/LicensesSelection';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/report/select', component: ReportSelection },
    { path: '/school/select', component: SchoolSelection },
    { path: '/teacher/select', component: TeacherSelection },
    { path: '/invoices/unpaid', component: UnpaidInvoices },
    { path: '/invoices/paid', component: PaidInvoices },
    { path: '/school/manage', component: ManageSchool },
    { path: '/school/manageteachers', component: ManageTeachers },
    { path: '/checkout/success', component: CheckoutSuccess },
    { path: '/checkout/unsuccessful', component: CheckoutFailure },
    { path: '/website', component: WebsiteIndex },
    { path: '/website/news', component: WebsiteNews },
    { path: '/licenses', component: LicensesSelection },
    { path: '/invoices', component: InvoicesIndex },
    {
      name: '/school/details',
      path: '/school/details/:schoolId',
      component: SchoolDetails,
      props: true,
    },
    {
      name: '/school/details',
      path: '/school/details',
      component: SchoolDetails,
      props: true,
    },
    {
      name: '/school/teachers',
      path: '/school/teachers/:school',
      component: ManageTeachers,
      props: true,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js